import React from "react";

import Stack from "@mui/material/Stack";
import { 
  FacebookShareButton, FacebookIcon, 
  TwitterShareButton, TwitterIcon, 
  TelegramShareButton, TelegramIcon, 
  WhatsappShareButton, WhatsappIcon, 
  LinkedinShareButton, LinkedinIcon, 
  PinterestShareButton, PinterestIcon, 
  RedditShareButton, RedditIcon, 
  EmailShareButton, EmailIcon 
} from "react-share";

function ShareSocial({ recipeURL, imageURL, name }) {
  const baseURL = window.location.protocol + "//" + window.location.hostname + "/food-recipe-react";
  recipeURL = baseURL + recipeURL;
  
  return (
    <>
      <Stack direction="row" spacing={0.5} mt={1}>
        {/* Facebook */}
        <FacebookShareButton url={recipeURL} quote={name}>
          <FacebookIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </FacebookShareButton>
        {/* Twitter (X) */}
        <TwitterShareButton url={recipeURL} title={name}>
          <TwitterIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </TwitterShareButton>
        {/* Telegram */}
        <TelegramShareButton url={recipeURL} title={name}>
          <TelegramIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </TelegramShareButton>
        {/* WhatsApp */}
        <WhatsappShareButton url={recipeURL} title={name}>
          <WhatsappIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </WhatsappShareButton>
        {/* Linkedin */}
        <LinkedinShareButton url={recipeURL} title={name}>
          <LinkedinIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </LinkedinShareButton>
        {/* Pinterest */}
        <PinterestShareButton url={recipeURL} media={imageURL} description={name}>
          <PinterestIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </PinterestShareButton>
        {/* Reddit */}
        <RedditShareButton url={recipeURL} title={name}>
          <RedditIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </RedditShareButton>
        {/* Email */}
        <EmailShareButton url={recipeURL} subject={name}>
          <EmailIcon size={24} round={true} bgStyle={{ fill: "#EEEEEE" }} iconFillColor={"#666666"} />
        </EmailShareButton>
      </Stack>
    </>
  );
}

export default ShareSocial;